import styled from 'styled-components'

export const ContentTextValue = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 16px;
`
